import { AfterContentInit, AfterViewInit, Component, Input, OnChanges, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { AsideService } from 'app/layout/components/aside-container/aside.service';
import { AddListComponent } from 'app/shared/components/add-list/add-list.component';
import { IconActionButtonEventMessage } from 'app/shared/components/icon-action-button-list/icon-action-button-list-message.model';
import { SystemActivityType } from 'app/shared/enumeration/system-activity-types';
import { SnackBarService } from 'app/shared/services/snack-bar.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import CaseActivityHelper from '../helpers/case-activity-helper';
import { CaseClaimListService } from 'app/modules/my-cases/services/case-claim-list.service';
import { Filter, FilterOperatorType } from 'app/shared/models/filter.model';

@Component({ standalone: false,
  selector: 'case-list',
  templateUrl: './case-list.component.html',
  styleUrls: ['./case-list.component.scss'],
  providers: [CaseClaimListService, { provide: 'IAddListService', useExisting: CaseClaimListService }],
})
export class CaseListComponent extends AddListComponent implements OnChanges, OnDestroy, OnInit, AfterViewInit, AfterContentInit {
  @Input() activityLevel: number;

  private sort: MatSort;
  private paginator: MatPaginator;
  matSortSubscribed;
  matPaginatorSubscribed;
  
  get displayedColumns(): string[] {
    return [ 'caseReference', 'name', 'createdByInitials', 'claimCreateDate'];
  }

  private ngUnsubscribe: Subject<boolean> = new Subject();

  constructor(
    protected activityListService: CaseClaimListService,
    private asideService: AsideService
  ) {
    super(activityListService);
    this.loadAfterInit = false;
    this.setFilers();
  }

  setFilers(){
    var filters: [Filter] = [{ field: "CaseStatus", operator: new FilterOperatorType().NotEquals, value: "Closed"}]
    this.activityListService.setFilters(filters);
  }

  ngAfterContentInit() {
  }

  iconFromActivityType(systemActivityType: SystemActivityType): string {
    return CaseActivityHelper.iconFromActivityType(systemActivityType);
  }

  get noItemsSelected(): boolean {
    return this.activityListService.getSelectedItemIds().length === 0;
  }

  @ViewChild(MatSort)
  set matSort(ms: MatSort) {
    this.sort = ms;
    if (this.sort) {
      if (this.matSortSubscribed) {
        this.matSortSubscribed.unsubscribe();
      }
      this.matSortSubscribed = this.sort.sortChange.subscribe((e) => {
        this.originalSort(e.active, e.direction);
      });
    }
  }

  @ViewChild(MatPaginator)
  set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    if (this.paginator) {
      if (this.matPaginatorSubscribed) {
        this.matPaginatorSubscribed.unsubscribe();
      }

      this.matPaginatorSubscribed = this.paginator.page.subscribe((e) => {
        this.service.ListRequest.pageNumber = e.pageIndex + 1;
        this.service.ListRequest.pageSize = e.pageSize;
        this.pageChanged();
      });
    }
  }

  ngOnChanges(): void {
    this.activityListService.reload();
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();

    this.asideService.asideClose.pipe(takeUntil(this.ngUnsubscribe)).subscribe((data) => {

      this.activityListService.reload();
    });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next(true);
    this.ngUnsubscribe.complete();
  }

  ngOnInit() {
    super.ngOnInit();
    this.setFilers();
  }

  pageChanged() {
    this.service.reload();
  }

  originalSort(column: string, direction: string) {
    this.service.setSort(column, direction);
  }

  doIconButtonAction(message: IconActionButtonEventMessage) {
  }

}
